import styled, { keyframes } from 'styled-components';

import { Menu, MenuItem } from '@szhsin/react-menu';
import {
  menuSelector,
  menuDividerSelector,
} from '@szhsin/react-menu/style-utils';

export const Container = styled.div``;

interface ILabel {
  background: string;
}

export const Label = styled.div<ILabel>`
  user-select: none;
  cursor: pointer;
  background: #e6edff;
  border-radius: 25px;
  color: #474d66;
  font-size: 12px;
  height: 30px;
  width: 112px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const menuShow = keyframes`
  from {
    opacity: 0;
  }
  `;
const menuHide = keyframes`
  to {
    opacity: 0;
  }
  `;

export const Dialog = styled(Menu)`
  ${menuSelector.name} {
    font-size: 0.925rem;
    user-select: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
    border-radius: 8px;
    transition: unset;
  }

  ${menuSelector.stateOpen} {
    animation: ${menuShow} 0.2s linear;
  }

  // NOTE: animation-fill-mode: forwards is required to
  // prevent flickering with React 18 createRoot()
  ${menuSelector.stateClosing} {
    animation: ${menuHide} 0.2s ease-out forwards;
  }

  ${menuDividerSelector.name} {
    margin: 0.5rem 0.625rem;
  }

  .szh-menu {
    min-width: unset !important;
    width: 112px !important;
    padding: 4px !important;
    background: #ffffff;
    box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
    border-radius: 4px;
  }
`;

export const Option = styled(MenuItem)`
  user-select: none;
  cursor: pointer;
  background: #e6edff;
  border-radius: 4px;
  color: #474d66;
  font-size: 12px;
  height: 30px;
  width: 100%;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;

  & + & {
    margin-top: 4px;
  }
`;

interface IOptionBall {
  color: string;
}

export const OptionBall = styled.div<IOptionBall>`
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background: ${({ color }) => color};
`;

export const OptionText = styled.div`
  padding-top: 1px;
  font-size: 12px;
  color: #474d66;
  font-weight: 400;
`;
